module.exports = __webpack_public_path__ + "static/media/ic-seta-branca.40933fbd.svg";